import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import {
  ValidationErrors,
  AbstractControl,
  ValidatorFn,
  Validators,
  UntypedFormBuilder,
  UntypedFormGroup,
} from "@angular/forms";
import { LoginService } from "src/app/services/login.service";
import {
  ActionSheetController,
  AlertController,
  LoadingController,
  ModalController,
  ToastController,
} from "@ionic/angular";
import { ProfileImageComponent } from "src/app/shared-module/components/profile-image/profile-image.component";
import { concat, Subscription } from "rxjs";

import { Common } from "src/app/core-files/common";
import { COMMA, ENTER } from "@angular/cdk/keycodes";
import { Router } from "@angular/router";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { MatChipInputEvent } from "@angular/material/chips";
import { ToastComponent } from "src/app/core-files/loaders/toast-messages";
import { SharedService } from "src/app/core-files/shared.service.";
import { SharedServices } from "src/app/services/shared.service";
@Component({
  selector: "app-agent-signup",
  templateUrl: "./agent-signup.component.html",
  styleUrls: ["./agent-signup.component.scss"],
  standalone: false
})
export class AgentSignupComponent implements OnInit {
  base64Image: any;
  registerForm: UntypedFormGroup;
  builderRegisterForm: UntypedFormGroup;
  formSubmitted: boolean = false;
  regReq: any;
  addOnBlur = true;
  readonly separatorKeysCodes = [ENTER, COMMA] as const;
  isImageSize: any = false;
  invalidOTP: boolean = false;
  isvalid: boolean = false;
  config = {
    allowNumbersOnly: false,
    length: 4,
    isPasswordInput: false,
    disableAutoFocus: false,
    placeholder: "",
    inputStyles: {
      width: "40px",
      height: "40px",
    },
  };
  flag: boolean;
  isAccept: boolean;
  fruits: any = [];
  otp: any;
  @ViewChild(ProfileImageComponent) fileField: ProfileImageComponent;
  isOTPSendReg: boolean = false;
  constructor(
    private _formBuilder: UntypedFormBuilder,
    private loginService: LoginService,
    public actionSheetController: ActionSheetController,
    public toastController: ToastController,
    public dialog: MatDialog,
    public alertController: AlertController,
    private loadingController: LoadingController,
    private toastComponent: ToastComponent,
    private sharedServices: SharedServices,
    private modalCtrl: ModalController,
  ) { }

  closeModal() {
    this.modalCtrl.dismiss();
  }

  ngOnInit() {
    this.regReq = {
      UserTypeId: 2,
      CompanyName: "",
      FName: "",
      LName: "a",
      Mobile2: "",
      Mobile1: "",
      OfficeContactNo: "0",
      Email: "",
      Password: "",
      RERA: "",
      SNICS: "",
      Country: "",
      State: "",
      Address: "",
      Area: "",
      OperateCity: "",
      City: "",
      Longitude: 11,
      Latitude: 11,
      WorkIn: "",
      OperateCityLat: 21,
      OperateCityLong: 22,
      DealIn: "",
      ProfilePic: "",
      AgentCode: "",
    };

    this.registerForm = this._formBuilder.group({
       Mobile1: [
        "",
        [
          Validators.required,
          Validators.minLength(10),
          Validators.pattern("^[0-9]*$"),
        ],
      ],
      FName: ["", [Validators.required]],
      CompanyName: ["", [Validators.required]],
      Email: ["", [Validators.required, Validators.email]],
      Password: "a",
      UserTypeId: 2,
      LName: "",
      Mobile2: 0,
      OfficeContactNo: 0,
      RERA: "",
      SNICS: "",
      Country: "",
      State: "",
      City: "",
      Area: "",
      Latitude: 0,
      Longitude: 0,
      Address: "",
      OperateCity: "",
      OperateCityLat: 0,
      OperateCityLong: 0,
      DealIn: "",
      WorkIn: "",
      AgentCode: "",
    });
  }

  onOtpChange(otp) {
    this.otp = otp;
    this.invalidOTP = false;
    if (otp.length === 4) {
      this.isvalid = true;
    } else {
      this.isvalid = false;
    }
  }
  async attemptRegister() {
    this.formSubmitted = true;
    if (this.registerForm.invalid) {
      this.registerForm.markAllAsTouched();
      return;
    }

    let object: any = {
      Mobileno: String(this.registerForm.value.Mobile1)
    }

    this.loginService.SignupSendotp(object).subscribe({
      next: async (res) => {
        this.toastComponent.showToast("OTP sent successfully", "success");
        this.isOTPSendReg = true;
      },
      error: err => {
        if (err.status == 406) {
          this.toastComponent.showToast("EmailId or mobile No already exist", "danger");
        } else {
          this.toastComponent.showToast("Registration fail try again", "danger");
        }
      }})

  }
  async submitOTPReg() {
    const loading = await this.loadingController.create({
      cssClass: "my-custom-class",
      message: "Validating OTP...",
    });
    await loading.present();
    let object = {
      Mobileno: String(this.registerForm.value.Mobile1),
      OtpValue: this.otp,
    }
    this.loginService.SignUpValidateRegOTP(object).subscribe({
      next: async (res) => {
        if (res.IsValid) {
          this.loginService.Registration(this.registerForm.value).subscribe({
            next: async (res) => {
              const toast = await this.toastController.create({
                message: "Registration Successfully",
                position: "top",
                duration: 2000,
                color: "success",
              });
              toast.present();
              await loading.dismiss();
             this.modalCtrl.dismiss();
            },
            error: async (error) => {
              await loading.dismiss();
              if (error.status == 406) {
                this.presentAlert(error.error);
                this.toastComponent.showToast("EmailId or mobile No already exist", "danger");
              } else {
                this.toastComponent.showToast("Registration fail try again", "danger");
                await loading.dismiss();
              }
            }
          });
        } else {
          this.invalidOTP = true;
          this.toastComponent.showToast("Invalid OTP", "danger");
        }
        await loading.dismiss();

      },
      error: async (err) => {
        this.invalidOTP = true;
        await loading.dismiss();
        this.toastComponent.showToast("Invalid OTP", "danger");

      }
    });
  }
  back() {
    this.isOTPSendReg = false;
    this.isvalid = false;
    this.invalidOTP = false;
  }

  showFieldError(controlName: string): boolean {
    const control = this.registerForm?.get(controlName);
    return !!control && control.invalid && (control.touched || control.dirty || this.formSubmitted);
  }

  getEmailErrorMessage(): string {
    const emailControl = this.registerForm?.get("Email");
    if (emailControl?.hasError("required")) {
      return "Email is required.";
    }
    return "Please enter a valid email address.";
  }

  getMobileErrorMessage(): string {
    const mobileControl = this.registerForm?.get("Mobile1");
    if (mobileControl?.hasError("required")) {
      return "Mobile number is required.";
    }
    if (mobileControl?.hasError("minlength")) {
      return "Mobile number must be 10 digits.";
    }
    return "Only numbers are allowed.";
  }

  async presentAlert(msg) {
    const alert = await this.alertController.create({
      cssClass: "my-custom-class",
      header: "Alert",
      message: "Mobile no or eamil already exist.",
      buttons: ["OK"],
    });

    await alert.present();

    const { role } = await alert.onDidDismiss();
  }
  goToLogin() {
    this.modalCtrl.dismiss();
    this.sharedServices.openUserLoginModal();
  }
}

